import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Landing page mappings for different user roles
 * Used to automatically redirect users to their appropriate dashboard
 */
const landingPages = {
  admin: '/dashboard',           // Admin Dashboard
  manager: '/bids',              // Transporter Manager - Bids
  staff_transport: '/bids',      // Transporter Staff - Bids
  manager_procurement: '/procurement-bids',  // Procurement Manager - Bids
  staff_procurement: '/procurement-bids',    // Procurement Staff - Bids
};

/**
 * RoleBasedRedirect Component
 * 
 * Automatically redirects authenticated users to their role-appropriate landing page.
 * Used for the root route to ensure users land on the correct dashboard.
 * 
 * @returns {React.ReactElement} Loading state or redirect component
 */
export default function RoleBasedRedirect() {
  const { currentUser, userRole, loading } = useAuth();

  // Show loading state while authentication is being checked
  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: 80 }}>
        Loading…
      </div>
    );
  }

  // Redirect to login if user is not authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to role-appropriate landing page
  const home = landingPages[userRole] || '/login';
  return <Navigate to={home} replace />;
}